import style from './_style.scss';
import { executeOnDocumentReady } from '../../../_shared/js/utils/executeOnDocumentReady';

import jQuery from 'jquery';
Object.assign(window, { $: jQuery, jQuery });

import Nette from 'nette-forms/src/assets/netteForms';
Object.assign(window, { Nette });

import ArrayRule from '../../../_shared/js/validators/ArrayRule.js';
ArrayRule();

import EmailRule from '../../../_shared/js/validators/EmailRule';
EmailRule();

import PasswordRule from '../../../_shared/js/validators/PasswordValidatorRule';
PasswordRule();

import PhoneValidatorRule from '../../../_shared/js/validators/PhoneValidatorRule';
PhoneValidatorRule();

Nette.initOnLoad();

require('../../../_shared/js/nette.ajax.js'); //je potreba, aby se nacetlo az po jQuery (import by šel přes ES6 proces, který má jiná pravidla)

import liveFormValidation from './js/parts/liveFormValidation';
liveFormValidation();

import scrollToFormError from './js/parts/scroll-to-form-error';
scrollToFormError();

import setupShowRegenerateButtonByDate from './js/parts/authForm';

setupShowRegenerateButtonByDate();

import rtable from './js/parts/rtable';
rtable();

import showMore from './js/parts/show-more';
showMore();

import confirm from './js/parts/confirm';
confirm();

import tippy from './js/parts/tippy';
tippy();

import tomSelect from './components/tom-select/index';
tomSelect();

import roleButtonKeydown from './js/parts/roleButtonKeydown.js';
roleButtonKeydown();

import lazyIframe from './js/parts/iframe-lazy';
lazyIframe();

import ReloadIfBrowserBack from './../../../_shared/js/utils/ReloadIfBrowserBack';
ReloadIfBrowserBack();

import LimitFromToDatePickers from './../../../_shared/js/utils/LimitFromToDatePickers';
LimitFromToDatePickers();

import activeLabelForInput from '../shared/js/parts/activeLabelForInput.js';
activeLabelForInput();

import inputUppercase from './../../../_shared/js/utils/inputUpperCase.js';
inputUppercase();

import SendDataToGTM from '../../../_shared/js/utils/SendDataToGTM';
SendDataToGTM(); // Toto musí jít před NetteFormMultipleSubmitPrevent, aby nedocházelo k zablokování tlačítka při druhém odeslání (po odeslání do GTM)

import NetteFormMultipleSubmitPrevent, { initializeButtons } from './js/NetteFormMultipleSubmitPrevent';
NetteFormMultipleSubmitPrevent();
window.initializeMultipleSubmitPrevent = function () {
	initializeButtons();
};

import candidatePopUp from './js/parts/candidatePopUp';
candidatePopUp();

import CustomUpload from './../../../_shared/js/CustomUpload/index.js';
CustomUpload();

require('./libs/remodal/remodal.js');
import './libs/remodal/remodal-default-theme.css';

import CommonUtils from './js/CommonUtils';
import LimitFromToSelectboxes from './../../../_shared/js/utils/LimitFromToSelectboxes';
import PreventDoubleSubmit from '../../../_shared/js/utils/PreventDoubleSubmit';
import PreventMultipleClickOnLink from '../../../_shared/js/utils/PreventMultipleClickOnLink';
import PreventDoubleSubmitAjax from './js/PreventDoubleSubmitAjax';
import cookieBar from './js/parts/cookie-bar';

import { Dropdown } from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
window.Modal = Modal;

import initBSModal from '../shared/js/parts/bsModal.js';
initBSModal();

import Collapse from 'bootstrap/js/dist/collapse.js';
window.Collapse = Collapse;

import openImgInModal from '../shared/js/parts/open-img-in-modal.js';

import commonOfferLike from './js/parts/common-offer-like';
commonOfferLike();

import 'swiped-events';

import safeTouchPatch from './js/parts/safe-touch-patch.js';

executeOnDocumentReady(() => {
	PreventMultipleClickOnLink();
});

window.addEventListener(
	'load',
	() => {
		safeTouchPatch();
		window.commonUtilsRefresh = () => CommonUtils();
		CommonUtils();
		LimitFromToSelectboxes();
		PreventDoubleSubmit();
		PreventDoubleSubmitAjax();
		cookieBar();
		openImgInModal();
	},
	{ once: true }
);
